export default __webpack_public_path__ + "static/cir-32c3fba9fb97619e091380e9575f1e18.png";